import { render, staticRenderFns } from "./activeData.vue?vue&type=template&id=3993fc7a&scoped=true"
import script from "./activeData.vue?vue&type=script&lang=js"
export * from "./activeData.vue?vue&type=script&lang=js"
import style0 from "./activeData.vue?vue&type=style&index=0&id=3993fc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993fc7a",
  null
  
)

export default component.exports